import { ContentType } from '../constants/ContentType';
import { getErrorDescription } from '../utils/mappers';
import { extendDeep, get } from '../utils/utils';
import { toItem } from './private-site/mappers/item';
import { ACL, defaultSettings } from './private-site/settings';
function toError(reason) {
  const errorDescription = getErrorDescription(reason);
  if (reason && reason.code === 403 && errorDescription === 'Missing Wix session') {
    reason.code = 401;
    reason.message = 'Wix Session required';
    reason.data.message = 'Wix Session required';
  } else if (errorDescription === 'site_token') {
    reason.message = 'Site token has expired';
    reason.data.message = 'Site token has expired';
  } else if (errorDescription === 'Tokens mismatch') {
    reason.message = 'Tokens mismatch';
    reason.data.message = 'Tokens mismatch';
  }
  if (reason.code === 400) {
    const {
      code,
      message,
      info
    } = get(reason, 'data.data.ext_response.payload.0', {});
    reason.code = 406;
    reason.message = message;
    reason.data = {
      error_code: code,
      error_description: message,
      error_info: info
    };
  }
  return Promise.reject(reason);
}
export const createImportAsyncMethod = (settings, http) => {
  if (!settings) {
    throw new Error('createImportAsyncMethod: settings are required');
  }
  if (!http) {
    throw new Error('createImportAsyncMethod: http is required');
  }
  settings = extendDeep({
    siteFilesSettings: defaultSettings
  }, settings);
  const defaultAcl = settings.namespace ? ACL.PRVATE : ACL.PUBLIC;
  function mapItem(res) {
    res.data = toItem(res.data.file, settings.siteFilesSettings);
    return res;
  }
  return (fileSource, options) => {
    if (!fileSource.file.id) {
      throw new Error('importAsync: fileSource.file.id is required');
    }
    options = options || {};
    const data = {
      file_id: fileSource.file.id,
      acl: fileSource.acl || defaultAcl
    };
    if (settings.siteMediaToken) {
      data.site_token = settings.siteMediaToken;
    }
    if (fileSource.language) {
      data.language = fileSource.language;
    }
    if (fileSource.folderId) {
      data.parent_folder_id = fileSource.folderId;
    }
    if (fileSource.tags && fileSource.tags.length) {
      data.labels = fileSource.tags.join(',');
    }
    if (fileSource.systemTags && fileSource.systemTags.length) {
      data.tags = fileSource.systemTags.join(',');
    }
    const vision = options.vision || settings.vision;
    if (vision) {
      data.vision = vision.join(',');
    }
    if (settings.namespace) {
      data.ns = settings.namespace;
    }
    const postOptions = {
      withCredentials: true,
      headers: {
        'Content-Type': ContentType.UrlEncoded
      }
    };
    return http.post("" + settings.apiUrl + settings.apiPath + "/download_async", data, null, postOptions).then(mapItem).catch(toError);
  };
};